// --- Energiehuisje configuraties per stationstype ---
const STATION_CONFIGURATIONS = {
   'Batenburg Mzb2-630': {
    width: 2.540,
    length: 1.975,
    buffer: [1, 0.858, 1, 0.858],
    doorSides: ["", [0.2, 1.575], "", [0.2, 1.575] ],
    doorWidth: 0.9,
    roosterSides: [[0.5, 0.8], "", "", ""],
    MSkabelvakSides: ["", [0.2, 1.575], "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: ["", "", "", [0.2, 1.575]],
    LSkabelvakLength: 2.5
  },
  'Batenburg Mzb2-1000': {
    width: 2.900,
    length: 2.100,
    buffer: [1, 0.9, 1, 0.9],
    doorSides: ["", [0.2, 1.7], "", [0.2, 1.7] ],
    doorWidth: 0.9,
    roosterSides: [[0.8, 0.7], "", "", ""],
    MSkabelvakSides: ["", [0.2, 1.7], "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: ["", "", "", [0.2, 1.575]],
    LSkabelvakLength: 2.5
  },
  'Batenburg Mrw-b': {
    width: 4.260,
    length: 2.510,
    buffer: [0.96, 1, 1.15, 0.8],
    doorSides: ["", "", [2, 1.15], "" ],
    doorWidth: 0.9,
    roosterSides: ["", "", "", [0.6, 1.31]],
    MSkabelvakSides: ["", "", [0.2, 3.86], ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: ["", "", [0.2, 3.86], "" ],
    LSkabelvakLength: 2.5
  },
  'Pacto25': {
    width: 3.555,
    length: 1.766,
    buffer: [1.3, 0.8, 0.94, 1.10],
    doorSides: [[0.2, 1.2, 0.2, 1.7], "", "", [0.5, 1]],
    doorWidth: 0.9,
    roosterSides: ["", "", "", ""],
    MSkabelvakSides: [[1.6, 1.7], "", "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: [[0.2, 1.2], "", "", ""],
    LSkabelvakLength: 2.5
  },
  'Pacto30': {
    width: 3.65,
    length: 2.015,
    buffer: [0.93, 0.86, 0.8, 1.135],
    doorSides: [[0.2, 1.9], [0.2, 1.6], "", [0.8, 1]],
    doorWidth: 0.9,
    roosterSides: ["", "", [0.3, 0.4], ""],
    MSkabelvakSides: ["", [0.2, 1.6], "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: [[0.2, 1.9], "", "", ""],
    LSkabelvakLength: 2.5
  },
    'Altro-1b ommetselbaar': {
    width: 3.260,
    length: 3.500,
    buffer: [0.8, 0.8, 0.8, 0.8],
    doorSides: [[1.03, 1.2], "", "", ""],
    doorWidth: 0.9,
    roosterSides: ["", [2.5, 0.8], [2.26, 0.8], ""],
    MSkabelvakSides: [[1.63, 1.43], "", "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: [[0.2, 1.43], "", "", ""],
    LSkabelvakLength: 2.5
  },
    'DS01': {
    width: 2.400,
    length: 3.700,
    buffer: [1, 0.8, 0.8, 0.8],
    doorSides: [[0.2, 1.2], "", "", ""],
    doorWidth: 0.9,
    roosterSides: ["", [2.07, 1], "", ""],
    MSkabelvakSides: [[0, 2.4], "", "", ""],
    MSkabelvakLength: 4.0,
    LSkabelvakSides: [[0, 2.4], "", "", ""],
    LSkabelvakLength: 2.5
  }
};

const KLEUR_NVT = 'n.v.t.';

// --- Soort werk, afgeleid uit het projectveld `type` ---------------------------
// `type` is vrije tekst uit de import ("LS - Netstation Ombouw", "LS - Vervangen
// station", ...) en is de enige bron die dit voor de hele portefeuille vult;
// `stationstype` is het kastmodel (Pacto25 etc.) en zegt hier niets over.
// Daarom matchen we op deelstring in kleine letters: dat is ongevoelig voor de
// rommelige varianten (afwijkende streepjes, tekenset-artefacten) in de data.
//
// - ombouw     -> bestaand station wordt omgebouwd (grijze rand)
// - vervangend -> nieuw station dat een bestaand station vervangt (blauwe rand)
// - null       -> regulier nieuw station (witte rand)
//
// Het te vervangen (bestaande) station krijgt een rode rand; dat volgt niet uit
// `type` maar uit de koppeling in station_vervanging.
const SOORT_TERMEN = { ombouw: 'ombouw', vervangen: 'vervangend' };

function soortVanType(type) {
  const t = (type || '').toLowerCase();
  for (const [term, soort] of Object.entries(SOORT_TERMEN)) {
    if (t.includes(term)) return soort;
  }
  return null;
}

// Dezelfde regel als MapLibre-expressie. Functies i.p.v. constanten, zodat elke
// laag zijn eigen expressie-array krijgt en MapLibre er nooit één deelt.
const typeKlein = () => ['downcase', ['to-string', ['get', 'type']]];
const isOmbouwExpr = () => ['in', 'ombouw', typeKlein()];
const isVervangendExpr = () => ['in', 'vervangen', typeKlein()];
// Alleen ombouw krijgt een icoon i.p.v. een footprint: daar wordt niets nieuws
// gebouwd. Een vervangend station is wél nieuwbouw en houdt dus zijn huisje.
const geenOmbouwExpr = () => ['!', isOmbouwExpr()];

// Helper: haal configuratie op voor stationstype
function getStationConfig(stationstype) {
  return STATION_CONFIGURATIONS[stationstype] || STATION_CONFIGURATIONS['Pacto25']; // fallback naar Pacto25
}

export {
  STATION_CONFIGURATIONS, getStationConfig, KLEUR_NVT,
  soortVanType, isOmbouwExpr, isVervangendExpr, geenOmbouwExpr,
};
